import { luminance, textOn } from '../common/PersonColor';

// How a shift block looks in every roster view (month, week, list, mobile):
//   published + assigned → filled with the person's colour, black/white text
//   draft + assigned     → pale tint of that colour, diagonal stripes, dashed border
//   open (any status)    → white, thick dashed red border, bold "OPEN"
//   person without colour → neutral grey instead of the colour
// Display only.

export const OPEN_LOOK = { bg: '#FFFFFF', border: '#DC2626', text: '#B91C1C' };
export const NO_COLOUR = '#9CA3AF';
const DARK_TEXT = '#1a1a2e';

// Blend hex `a` towards hex `b` by share t (0 = a, 1 = b)
export function mix(a, b, t) {
  const pa = parseInt(a.slice(1), 16);
  const pb = parseInt(b.slice(1), 16);
  const ch = (shift) => Math.round(((pa >> shift) & 255) * (1 - t) + ((pb >> shift) & 255) * t);
  return `#${[16, 8, 0].map((s) => ch(s).toString(16).padStart(2, '0')).join('')}`.toUpperCase();
}

export function shiftLook(slot, colour) {
  if (!slot?.assigned_user_id) {
    return {
      kind: 'open', bg: OPEN_LOOK.bg, stripe: null, text: OPEN_LOOK.text,
      borderColor: OPEN_LOOK.border, borderStyle: 'dashed', borderWidth: 3,
    };
  }
  const c = luminance(colour) == null ? NO_COLOUR : colour.toUpperCase();
  if (slot.period_status === 'draft') {
    const bg = mix(c, '#FFFFFF', 0.82);
    const stripe = mix(c, '#FFFFFF', 0.62);
    return { kind: 'draft', bg, stripe, text: textOn(stripe), borderColor: c, borderStyle: 'dashed', borderWidth: 2 };
  }
  return { kind: 'published', bg: c, stripe: null, text: textOn(c), borderColor: mix(c, '#000000', 0.3), borderStyle: 'solid', borderWidth: 1 };
}

// Inline style for a block (background, stripes, border, text colour)
export function lookStyle(look) {
  return {
    backgroundColor: look.bg,
    backgroundImage: look.stripe
      ? `repeating-linear-gradient(135deg, ${look.stripe} 0 4px, ${look.bg} 4px 9px)`
      : 'none',
    border: `${look.borderWidth}px ${look.borderStyle} ${look.borderColor}`,
    color: look.text,
  };
}

// Small white chip so icons and notes (📌, cover, ≠) stay readable on any fill
export const CHIP_STYLE = {
  display: 'inline-block', background: '#FFFFFF', color: DARK_TEXT, borderRadius: '999px',
  padding: '0 4px', lineHeight: 1.35, boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.18)', flexShrink: 0,
};
